import { c as _c } from "react/compiler-runtime";
import { cn, IconButtonAsButton, Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@newfront-insurance/core-ui/v2';
import { useChatOverlayContext } from '../../contexts/chat-overlay-context';
import { IconFullscreen, IconMinimize } from '../icons';
interface ChatHeaderActionsProps {
  className?: string;
}

/**
 * Header actions component for fullscreen toggle and close button.
 * Uses context to access state and handlers.
 */
export function ChatHeaderActions(t0) {
  const $ = _c(21);
  const {
    className
  } = t0;
  const {
    isStandaloneMode,
    isFullscreen,
    setIsFullscreen,
    onClose
  } = useChatOverlayContext();
  if (isStandaloneMode) {
    return null;
  }
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex items-center gap-2", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== isFullscreen || $[3] !== setIsFullscreen) {
    t2 = () => setIsFullscreen(!isFullscreen);
    $[2] = isFullscreen;
    $[3] = setIsFullscreen;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <IconFullscreen />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2) {
    t4 = <TooltipTrigger><IconButtonAsButton onClick={t2}>{t3}</IconButtonAsButton></TooltipTrigger>;
    $[6] = t2;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <TooltipContent>Toggle Fullscreen</TooltipContent>;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4) {
    t6 = <Tooltip>{t4}{t5}</Tooltip>;
    $[9] = t4;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <IconMinimize />;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== onClose) {
    t8 = <TooltipTrigger><IconButtonAsButton onClick={onClose}>{t7}</IconButtonAsButton></TooltipTrigger>;
    $[12] = onClose;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <TooltipContent>Minimize</TooltipContent>;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t8) {
    t10 = <Tooltip>{t8}{t9}</Tooltip>;
    $[15] = t8;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t1 || $[18] !== t10 || $[19] !== t6) {
    t11 = <TooltipProvider><div className={t1}>{t6}{t10}</div></TooltipProvider>;
    $[17] = t1;
    $[18] = t10;
    $[19] = t6;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  return t11;
}